(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-bundles"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ss-bundle-builder'))customElements.define('ss-bundle-builder',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.form=this.querySelector('form');this.button=this.querySelector('[data-add]');this.status=this.querySelector('[data-status]');this.total=this.querySelector('[data-total]');this.selects=[...this.querySelectorAll('[data-variant]')];this.button.hidden=false;this.addEventListener('change',()=>this.update());this.form.addEventListener('submit',e=>this.add(e));this.update()}update(){let amount=this.selects.reduce((n,s)=>n+Number(s.options[s.selectedIndex]?.dataset.price||0),0);this.total.textContent=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:this.dataset.currency}).format(amount/100);this.button.disabled=!!this.pending||this.selects.some(s=>!s.value)}async add(e){e.preventDefault();if(this.button.disabled||this.pending)return;this.pending=true;this.status.classList.remove('ss-error');this.button.disabled=true;this.button.setAttribute('aria-busy','true');this.status.textContent=this.dataset.adding;let drawer=document.querySelector('cart-drawer');drawer?.setActiveElement(this.button);let counts=new Map();this.selects.forEach(s=>counts.set(Number(s.value),(counts.get(Number(s.value))||0)+1));let items=[...counts].map(([id,quantity])=>({id,quantity}));let body={items};if(drawer){body.sections=drawer.getSectionsToRender().map(s=>s.id);body.sections_url=window.location.pathname}let added=false;try{let response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});let data=await response.json();if(!response.ok||data.status)throw new Error(data.description||this.dataset.error);added=true;this.status.textContent=this.dataset.success;if(drawer&&data.sections?.['cart-drawer']&&data.sections?.['cart-icon-bubble']){drawer.classList.remove('is-empty');drawer.renderContents(data);if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'ss-bundle-builder',cartData:data})}else{window.location.assign(this.dataset.cartUrl)}}catch(error){if(added){window.location.assign(this.dataset.cartUrl);return}this.status.textContent=error.message||this.dataset.error;this.status.classList.add('ss-error')}finally{this.pending=false;this.button.removeAttribute('aria-busy');this.update()}}});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-editorial-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shuja-hero')) {
    class ShujaHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-ss-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-ss-dot]'));
        this.previousButton = this.querySelector('[data-ss-previous]');
        this.nextButton = this.querySelector('[data-ss-next]');
        this.toggleButton = this.querySelector('[data-ss-toggle]');
        this.status = this.querySelector('[data-ss-status]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.delay = Number(this.dataset.delay) || 4000;
        this.canAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.supportsHover = window.matchMedia('(hover: hover)').matches;
        this.userPaused = false;
        this.hoverPaused = false;
        this.touchStartX = 0;
        this.touchStartY = 0;

        if (this.slides.length < 2) return;

        this.onPrevious = () => this.goTo(this.index - 1, true);
        this.onNext = () => this.goTo(this.index + 1, true);
        this.onToggle = () => this.toggleAutoplay();
        this.onMouseEnter = () => {
          this.hoverPaused = true;
          this.stopAutoplay();
        };
        this.onMouseLeave = () => {
          this.hoverPaused = false;
          this.startAutoplay();
        };
        this.onTouchStart = (event) => {
          const touch = event.changedTouches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.stopAutoplay();
        };
        this.onTouchEnd = (event) => {
          const touch = event.changedTouches[0];
          const distanceX = touch.clientX - this.touchStartX;
          const distanceY = touch.clientY - this.touchStartY;

          if (Math.abs(distanceX) > 50 && Math.abs(distanceX) > Math.abs(distanceY) * 1.25) {
            this.goTo(distanceX < 0 ? this.index + 1 : this.index - 1, true);
          } else {
            this.startAutoplay();
          }
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        };
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const selectedIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selectedIndex > -1) {
            this.userPaused = true;
            this.goTo(selectedIndex, false);
            this.stopAutoplay();
            this.updateToggle();
          }
        };

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.toggleButton?.addEventListener('click', this.onToggle);
        if (this.supportsHover) {
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
        }
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.ssDot), true));
        });

        if (this.reducedMotion && this.toggleButton) this.toggleButton.hidden = true;
        this.restartProgress();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.toggleButton?.removeEventListener('click', this.onToggle);
        if (this.supportsHover) {
          this.removeEventListener('mouseenter', this.onMouseEnter);
          this.removeEventListener('mouseleave', this.onMouseLeave);
        }
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      goTo(requestedIndex, announce) {
        const nextIndex = (requestedIndex + this.slides.length) % this.slides.length;
        this.index = nextIndex;

        this.slides.forEach((slide, index) => {
          const isActive = index === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          if (isActive) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });

        if (announce && this.status) {
          const productName = this.dots[nextIndex]?.getAttribute('aria-label')?.split(': ').pop() || '';
          this.status.textContent = `Slide ${nextIndex + 1} of ${this.slides.length}: ${productName}`;
        }

        this.restartProgress();
        this.restartAutoplay();
      }

      startAutoplay() {
        if (!this.canAutoplay || this.reducedMotion || this.userPaused || this.hoverPaused || document.hidden) return;
        this.classList.remove('is-paused');
        this.stopTimerOnly();
        this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.delay);
      }

      stopTimerOnly() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      stopAutoplay() {
        this.stopTimerOnly();
        this.classList.add('is-paused');
      }

      restartAutoplay() {
        this.stopTimerOnly();
        this.startAutoplay();
      }

      toggleAutoplay() {
        this.userPaused = !this.userPaused;
        if (this.userPaused) this.stopAutoplay();
        else this.startAutoplay();
        this.updateToggle();
      }

      updateToggle() {
        if (!this.toggleButton) return;
        this.classList.toggle('is-user-paused', this.userPaused);
        this.toggleButton.setAttribute('aria-pressed', String(this.userPaused));
        this.toggleButton.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
      }

      restartProgress() {
        const progress = this.querySelector('.ss-hero__progress span');
        if (!progress) return;
        progress.style.animation = 'none';
        progress.offsetHeight;
        progress.style.animation = '';
      }
    }

    customElements.define('shuja-hero', ShujaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-reviews"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ss-reviews'))customElements.define('ss-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('select')?.addEventListener('change',e=>{let count=0;this.querySelectorAll('[data-rating]').forEach(card=>{card.hidden=e.target.value!=='all'&&card.dataset.rating!==e.target.value;if(!card.hidden)count++});this.querySelector('[data-empty]').hidden=count>0})}});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-scent-finder"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ss-scent-finder'))customElements.define('ss-scent-finder',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.steps=[...this.querySelectorAll('fieldset')];this.cards=[...this.querySelectorAll('[data-scent]')];this.index=0;this.next=this.querySelector('[data-next]');this.back=this.querySelector('[data-back]');this.result=this.querySelector('[data-result]');this.querySelector('[data-actions]').hidden=false;this.querySelector('[data-nojs]').hidden=true;this.addEventListener('change',()=>{this.next.disabled=!this.steps[this.index].querySelector('input:checked')});this.next.addEventListener('click',()=>{if(!this.steps[this.index].querySelector('input:checked'))return;if(this.index<2){this.index++;this.paint()}else this.showResult()});this.back.addEventListener('click',()=>{this.index=Math.max(0,this.index-1);this.paint()});this.querySelector('[data-restart]').addEventListener('click',()=>{this.result.hidden=true;this.index=0;this.paint()});this.paint(false)}paint(focus=true){this.steps.forEach((s,i)=>s.hidden=i!==this.index);this.querySelector('[data-actions]').hidden=false;this.back.hidden=this.index===0;this.next.textContent=this.index===2?this.dataset.resultsLabel:this.dataset.nextLabel;this.next.disabled=!this.steps[this.index].querySelector('input:checked');this.querySelector('[data-progress]').textContent=`${this.index+1} / 3`;if(focus)this.steps[this.index].querySelector('legend').focus()}showResult(){let answers=this.steps.map(s=>s.querySelector('input:checked').value);let ranked=this.cards.map((card,i)=>({card,i,score:['family','occasion','intensity'].reduce((score,key,k)=>score+(card.dataset[key]?.toLowerCase().split(',').map(x=>x.trim()).includes(answers[k])?[3,2,1][k]:0),0)})).sort((a,b)=>b.score-a.score||a.i-b.i);this.cards.forEach(c=>c.hidden=true);ranked.slice(0,2).forEach(({card})=>{card.hidden=false;card.parentNode.appendChild(card)});this.steps.forEach(s=>s.hidden=true);this.querySelector('[data-actions]').hidden=true;this.result.hidden=false;this.querySelector('[data-result-heading]').textContent=ranked[0]?.score>0?this.dataset.matchLabel:this.dataset.exploreLabel;this.querySelector('[data-result-heading]').focus()}});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-sticky-buy"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-sticky-buy'))customElements.define('ss-sticky-buy',class extends HTMLElement{connectedCallback(){if(this.observer)return;this.bar=this.querySelector('[data-sticky-bar]');this.target=document.querySelector('product-info .product-form__buttons');this.button=this.querySelector('button');if(!this.target)return;this.observer=new IntersectionObserver(entries=>{this.bar.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0},{threshold:0});this.observer.observe(this.target);this.sync=()=>{const original=this.target.querySelector('button[name="add"]');this.button.disabled=!original||original.disabled||original.getAttribute('aria-disabled')==='true'};this.mutation=new MutationObserver(this.sync);this.mutation.observe(this.target,{attributes:true,subtree:true,childList:true});this.sync();this.click=()=>{this.sync();if(this.button.disabled)return;const original=this.target.querySelector('button[name="add"]');original?.click()};this.button.addEventListener('click',this.click)}disconnectedCallback(){this.observer?.disconnect();this.observer=null;this.mutation?.disconnect();this.button?.removeEventListener('click',this.click)}});

  } catch(e) { console.error(e); }
})();
})();
